const defaultState = {
    todo: true,
    burritos: false,
    tacos: false,
    enchiladas: false,
    nachos: false,
    empanadas: false,
    pasta: false,
    arroz: false,
    suplementos: false,
    quesadillas: false,
    croquetas: false,
    postres: false,
    bebidas: false,
    otros: false,
    search: false
}

function categoriesToggler( state = defaultState, { type }){
    switch (type) {
        case 'todo': {
            return { ...defaultState,
                todo: true}
        }
        case 'burritos': {
            return { ...defaultState,
                todo: false,
                burritos: true}
        }
        case 'tacos': {
            return { ...defaultState,
                todo: false,
                tacos: true}
        }
        case 'enchiladas': {
            return { ...defaultState, 
                todo: false,
                enchiladas: true}
        }
        case 'nachos': {
            return { ...defaultState,
                todo: false,
                nachos: true}
        }
        case 'empanadas': {
            return { ...defaultState,
                todo: false,
                empanadas: true}
        }
        case 'pasta': {
            return { ...defaultState,
                todo: false,
                pasta: true}
        }
        case 'arroz': {
            return { ...defaultState,
                todo: false,
                arroz: true}
        }
        case 'suplementos': {
            return { ...defaultState,
                todo: false,
                suplementos: true}
        }
        case 'quesadillas': {
            return { ...defaultState,
                todo: false,
                quesadillas: true}
        }
        case 'croquetas': {
            return { ...defaultState,
                todo: false,
                croquetas: true}
        }
        case 'postres': {
            return { ...defaultState,
                todo: false,
                postres: true}
        }
        case 'bebidas': {
            return { ...defaultState,
                todo: false,
                bebidas: true}
        }
        case 'otros': {
            return { ...defaultState,
                todo: false,
                otros: true}
        }
        case 'search': {
            return { ...defaultState,
                todo: false,
                search: true}
        }
        default:
            return state;
    }
}

export default categoriesToggler;